import {
	ClickAwayListener,
	IconButton,
	Tooltip,
	type TooltipProps,
	useTheme,
} from "@mui/material";
import { Info } from "lucide-react";
import { useCallback, useState } from "react";

interface PropertyWidgetTooltipProps
	extends Omit<TooltipProps, "children" | "onToggle"> {
	size?: number;
	onToggle?: (open: boolean) => void;
}

export const PropertyWidgetTooltip = ({
	size = 16,
	onToggle,
	...tooltipProps
}: PropertyWidgetTooltipProps) => {
	const { palette } = useTheme();
	const [open, setOpen] = useState(false);

	const close = useCallback(() => {
		setOpen(false);
		onToggle?.(false);
	}, [onToggle]);

	const toggle = useCallback(() => {
		setOpen((prev) => {
			const next = !prev;
			onToggle?.(next);
			return next;
		});
	}, [onToggle]);

	return (
		<ClickAwayListener onClickAway={close}>
			<Tooltip
				arrow
				placement="top"
				disableFocusListener
				disableHoverListener
				disableTouchListener
				{...tooltipProps}
				open={open}
				onClose={close}
			>
				<IconButton onClick={toggle} sx={{ p: 0, ml: 0.4 }}>
					<Info color={palette.darkmodeText.white} size={size} />
				</IconButton>
			</Tooltip>
		</ClickAwayListener>
	);
};
